import { AbstractControl } from '@angular/forms';

export function getErrorKey(err: { error: { data: { field: string, errors: string[]}[] } }) {
  if (err.error && err.error.data) {
    return err.error.data[0].errors[0];
  }
  return [];
}

export function applyErrors(form: AbstractControl, d: any) {
  const data = d?.error?.data
  for (const err of data) {
    if (!Array.isArray(err.errors) || !err.errors.length) continue;
    const control = form.get(err.field);
    const errCode = err.errors[0];

    if (control) {
      control.setErrors({ [errCode]: true });
    }
  }
}
